// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import { string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import FeedbackFormComponent from 'Components/FeedbackForm/FeedbackForm';
import { API_ORDER_FEEDBACK } from 'Constants';
import useFetch from 'Hooks/useFetch';
import useAnalytics from 'Hooks/useAnalytics';

const FeedbackForm = ({ orderId }) => {
  const fetch = useFetch();
  const { t } = useTranslation();
  const analytics = useAnalytics();
  const [feedback, setFeedback] = useState(null);
  const [success, setSuccess] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tempRating, setTempRating] = useState(null);
  const [rating, setRating] = useState(null);
  const onChange = evt => setFeedback(evt.target?.value?.trim());

  const handleOnSubmit = async () => {
    analytics.track('order_feedback', { stars: rating });
    if (rating === null) {
      setErr(t('order.feedback.provideRating'));
      return;
    }

    try {
      setErr(null);
      setSuccess(null);
      setLoading(true);
      await fetch(API_ORDER_FEEDBACK, {
        method: 'POST',
        body: JSON.stringify({ opinion: feedback, stars: rating, orderId })
      });
      setSuccess(true);
    } catch (e) {
      setSuccess(false);
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleOnMouseOver = idx => {
    setTempRating(idx);
  };

  const handleOnMouseOut = () => setTempRating(null);

  return (
    <FeedbackFormComponent
      orderId={ orderId }
      error={ err }
      loading={ loading }
      success={ success }
      rating={ rating }
      tempRating={ tempRating }
      handleOnSetRating={ setRating }
      handleOnChange={ onChange }
      onSubmit={ handleOnSubmit }
      onMouseOver={ handleOnMouseOver }
      onMouseOut={ handleOnMouseOut }
    />
  );
};

FeedbackForm.propTypes = {
  orderId: string,
};
FeedbackForm.displayName = 'FeedbackFormContainer';

export default FeedbackForm;
